import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { MenuController, NavController } from '@ionic/angular';
import { IProductoWeb } from 'src/app/interfaces/IProductoWeb';
import { DeviceInfoService } from 'src/app/services/deviceInfo/device-info.service';

import { GlobalConstants, WebAPIConstants } from 'src/app/services/globalConstants/global-constants.service';
import { ProductoService } from 'src/app/services/producto/producto.service';

import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { VisitaService } from 'src/app/services/visita/visita.service';

@Component({
  selector: 'app-producto',
  templateUrl: './producto.page.html',
  styleUrls: ['./producto.page.scss'],
})
export class ProductoPage implements OnInit {

  //#region Propiedades

  public _appVersion: string;

  public _utmCampaign: string = null;
  public _utmContent: string = null;
  public _utmMedium: string = null;
  public _utmSource: string = null;
  public _utmTerm: string = null;

  public _idProducto: number = null;
  public _productoWeb: IProductoWeb = this._productoSrv.getNewProductoWeb();

  //#endregion Propiedades

  //#region Constructor

  constructor(private _route: ActivatedRoute,
              private _navCtrl: NavController,
              private _menuCtrl: MenuController,
              private _usuarioSrv: UsuarioService,
              private _visitaSrv: VisitaService,
              private _productoSrv: ProductoService,
              private _deviceInfoSrv: DeviceInfoService) {

    console.log('ProductoPage >> constructor');

  }

  //#endregion Constructor

  //#region Eventos NG

  public ngOnInit() {
    console.log('ProductoPage >> ngOnInit');
    this._menuCtrl.enable(false);
  }

  public async ionViewDidEnter() {
    console.log('ProductoPage >> ionViewDidEnter');

    this._appVersion = GlobalConstants.APP_VERSION;

    // recupera el producto desde el query string, si existe
    await this._route.queryParams.subscribe((params) => {
      if (params['q'] == undefined) { // no trae query params...redirige pagina principal de categorias

        this._navCtrl.navigateForward('/categoria');

      } else {

        // asigna variable
        this._idProducto = params['q'];
      }
    });

    console.log('ProductoPage >> ionViewDidEnter >> idProducto >> ' + this._idProducto);

    // recupera/crea/guarda token publico
    await this._usuarioSrv.doPublicToken();

    // registra visita
    await this._route.queryParams.subscribe((params) => {

      // recupera datos de UTM
      if (params['utm_campaign'] !== undefined) { this._utmCampaign = params['utm_campaign']; }
      if (params['utm_content'] !== undefined) { this._utmContent = params['utm_content']; }
      if (params['utm_medium'] !== undefined) { this._utmMedium = params['utm_medium']; }
      if (params['utm_source'] !== undefined) { this._utmSource = params['utm_source']; }
      if (params['utm_term'] !== undefined) { this._utmTerm = params['utm_term']; }

      this._visitaSrv.guardar('Producto', null, null,
      null, this._idProducto, null, null,
      null, null,
      this._utmCampaign, this._utmContent, this._utmMedium, this._utmSource, this._utmTerm).subscribe();
    });

    // recupera el nombre de la ubicacion actual
    let location;
      
    const geocoder = new google.maps.Geocoder();
    //await geocoder.geocode({location:{lat:25.67507,lng:-100.31847}}, function(result, status) {
    await geocoder.geocode({location:{lat:this._deviceInfoSrv.CurrentDeviceInfo.DeviceLat,lng:this._deviceInfoSrv.CurrentDeviceInfo.DeviceLng}}, function(result, status) {
    
      if (status !== google.maps.GeocoderStatus.OK) return;
      
      const {long_name} = result[0]['address_components'][3];
      location = long_name;
    });

    // Recupera datos del producto
    this._productoSrv.getProductoWeb(this._idProducto, location).subscribe(() => {
      this._productoWeb = this._productoSrv.CurrentProductoWeb;
      this._productoWeb.UrlImagenDetalle = WebAPIConstants.URLProductoImagenes + this._productoWeb.UrlImagenDetalle;
    });
  }

  public ionViewDidLeave() {
    console.log('ProductoPage >> ionViewDidLeave');

    this._idProducto = null;
    this._productoWeb = this._productoSrv.getNewProductoWeb();

  }

  //#endregion Eventos NG

  //#region Eventos Botones

  //#endregion

  //#region Otros Metodos

  public getCategoriaWidth(): string {
    const w: number = document.getElementById('spanProductoSubtituloText').offsetWidth;
    if ( w > 0 ) {
      return 'max-width: ' + (w + 80) + 'px;';
    } else {
      return 'max-width: auto;';
    }
  }

  //#endregion

}
